<div class="privacy-policy-container">
  <div class="privacy-policy-content">
    <h1>Privacy Policy</h1>
    <p class="last-updated">Last Updated: February 11, 2026</p>

    <section>
      <h2>Introduction</h2>
      <p>
        Welcome to D2ArmorPicker. This Privacy Policy explains how this service collects and uses
        your personal information. D2ArmorPicker is committed to being transparent about data
        practices.
      </p>
    </section>

    <section>
      <h2>Information We Collect</h2>

      <h3>Personal Information</h3>
      <p>When you use D2ArmorPicker, we may collect the following types of information:</p>
      <ul>
        <li
          ><strong>Bungie Account Information:</strong> Your Bungie username and associated game
          data when you authenticate with our service</li
        >
        <li><strong>IP Address:</strong> Your IP address for analytics purposes</li>
        <li
          ><strong>Usage Data:</strong> Information about how you interact with our service,
          including pages visited and features used</li
        >
      </ul>

      <h3>Destiny 2 Game Data</h3>
      <p>
        When you connect your Bungie account, this service accesses your Destiny 2 character
        information, armor pieces, and related game data through the Bungie API. This information is
        used solely to provide armor optimization services.
      </p>
    </section>

    <section>
      <h2>How We Use Your Information</h2>
      <p>The collected information is used for the following purposes:</p>
      <ul>
        <li>To provide and maintain services</li>
        <li>To authenticate your identity and ensure access to your game data</li>
        <li>To analyze usage patterns and improve the service</li>
        <li>To troubleshoot technical issues and provide support</li>
      </ul>
    </section>

    <section>
      <h2>Data Storage and Security</h2>
      <p>
        Game data retrieved from the Bungie API is processed in real-time and may be cached
        temporarily to improve performance. Sensitive account credentials are not stored.
      </p>
      <p
        >We take reasonable measures to protect your information from unauthorized access, use, or
        disclosure.</p
      >
      <p
        >Information of usage patterns, errors and activity may be collected to improve the
        service.</p
      >
    </section>

    <section>
      <h2>Data Sharing</h2>
      <p>
        Your personal information is not sold, traded, or otherwise transferred to third parties
        except in the following circumstances:
      </p>
      <ul>
        <li>When required by law or to comply with legal processes</li>
        <li>To protect the rights, privacy, safety, or property of this service</li>
      </ul>
      <p>
        Third-party services may be used for analytics and error tracking. These services are bound
        by their own privacy policies and data processing agreements.
      </p>
    </section>

    <section>
      <h2>Cookies and Local Storage</h2>
      <p>
        This service uses browser local storage to save your preferences, settings, and temporary
        data to enhance your experience. This information remains on your device and can be cleared
        through your browser settings.
      </p>
    </section>

    <section>
      <h2>Third-Party Links</h2>
      <p>
        This service may contain links to third-party websites or services. D2ArmorPicker is not
        responsible for the privacy practices of these external sites. You are encouraged to review
        their privacy policies.
      </p>
    </section>

    <section>
      <h2>Changes to This Privacy Policy</h2>
      <p>
        This Privacy Policy may be updated from time to time. You will be notified of any changes by
        posting the new Privacy Policy on this page and updating the "Last Updated" date.
      </p>
    </section>

    <section>
      <h2>Contact Us</h2>
      <p>
        If you have any questions about this Privacy Policy or data practices, please reach out
        through the following channels:
      </p>
      <ul>
        <li
          >GitHub Issues:
          <a href="https://github.com/Mijago/D2ArmorPicker/issues" target="_blank" rel="noopener"
            >D2ArmorPicker Issues</a
          ></li
        >
        <li>Discord Community: Available through the help section</li>
      </ul>
    </section>

    <section class="acknowledgment">
      <h2>Bungie.net API</h2>
      <p>
        This service uses the Bungie.net API. Bungie's Privacy Policy applies to data accessed
        through their API. You can review Bungie's Privacy Policy at
        <a href="https://www.bungie.net/en/View/privacypolicy" target="_blank" rel="noopener"
          >https://www.bungie.net/en/View/privacypolicy</a
        >.
      </p>
      <h2>OpenReplay</h2>
      <p>
        This service uses OpenReplay for session replay and analytics. OpenReplay's Privacy Policy
        applies to data collected through their services. You can review OpenReplay's Privacy Policy
        at
        <a href="https://openreplay.com/privacy" target="_blank" rel="noopener"
          >https://openreplay.com/privacy</a
        >.
      </p>
      <h2>Sentry</h2>
      <p>
        This service uses Sentry for error tracking and monitoring. Sentry's Privacy Policy applies
        to data collected through their services. You can review Sentry's Privacy Policy at
        <a href="https://sentry.io/privacy/" target="_blank" rel="noopener"
          >https://sentry.io/privacy/</a
        >.
      </p>
    </section>

    <div class="back-to-login">
      <a routerLink="/" class="back-link">← Back</a>
    </div>
  </div>
</div>
